import { portalAction, portalScreenContext } from '../../app/telemetry/portalTelemetry';
import { usePortalScreen } from '../../app/telemetry/usePortalTelemetry';
import { Button, Grid, Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { ApiRequestStatus } from "../../app/enums/apiRequestStatus";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { useAppSelector } from "../../app/store/configureStore";
import { useGetCreditSummary } from "../../app/customHooks/useGetCreditSummary";
import { MESSAGE_PROCESSING_DETAILS } from "../../app/utils/constant";
import { useGetPcsCurrentYear } from "../../app/customHooks/useGetPcsCurrentYear";
import { useGetRegistrationDetails } from "../../app/customHooks/useGetRegistrationDetails";
import { useReferenceData } from "../../app/customHooks/useReferenceData";
import { useGetPersonalDetails } from "../../app/customHooks/useGetPersonalDetails";
import SummaryTable from "./SummaryTable";
import LegacySummaryTable from "./LegacySummaryTable";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { useState, useEffect } from "react";
import { SummaryDto } from "../../app/models/summary/summaryDto";
import PdfDocument from "./PdfDocument";
import SummaryTableMobileView from "./SummaryTableMobileView";

export default function SummaryForm() {
    const { summaryTitles, summaryData, legacyTitles, legacySummaryData, currentYear, registrationDetails, getCreditSummaryStatus,
        currentYearStatus, registerStateStatus } = useAppSelector(state => state.pcs);
    const { schemes, registrationTypes, titles, staticDataStateStatus } = useAppSelector(state => state.ReferenceData);
    const { personalDetails, personalDetailsStatus } = useAppSelector(state => state.personalDetail);

    useReferenceData();
    useGetCreditSummary();
    useGetPcsCurrentYear();
    useGetRegistrationDetails();
    useGetPersonalDetails();

    const [creditSummaryData, setCreditSummaryData] = useState<SummaryDto[][] | null>(null);
    const [sixYearSummaryData, setSixYearSummaryData] = useState<SummaryDto[][] | null>(null);
    const [totalOfSummary, setTotalOfSummary] = useState<number[]>([]);
    const [isYearPartialyCompleted, setIsYearPartialyCompleted] = useState<boolean>(false);

    const [legacyCreditSummaryData, setLegacyCreditSummaryData] = useState<SummaryDto[][] | null>(null);
    const [legacySixYearSummaryData, setLegacySixYearSummaryData] = useState<SummaryDto[][] | null>(null);
    const [isLegacyYearPartialyCompleted, setIsLegacyYearPartialyCompleted] = useState<boolean>(false);

    useEffect(() => {
        if (summaryData && currentYear !== null) {
            let creditSummary: SummaryDto[][] = [];
            let sixYearSummary: SummaryDto[][] = [];
            let totalSummary: number[] = [];
            summaryData.map((item: SummaryDto[], index) => {
                if (index < 6) {
                    if (item[0].text.substring(0, 4) !== currentYear.toString()) {
                        creditSummary[creditSummary.length] = item;
                    }
                    sixYearSummary[index] = item;
                }

                let isYearPartialyComplete = false;
                if (item[2].text.toLowerCase() === "true") {
                    if (isYearPartialyComplete === false) {
                        setIsYearPartialyCompleted(true);
                    }
                }
                totalSummary.push(parseFloat(item[3].text.split(' (')[0]) + parseFloat(item[4].text.split(' (')[0]) + parseFloat(item[5].text.split(' (')[0]) + parseFloat(item[6].text.split(' (')[0]));
            });
            setCreditSummaryData(creditSummary);
            setSixYearSummaryData(sixYearSummary);
            setTotalOfSummary(totalSummary);
        }
    }, [summaryData, currentYear]);

    useEffect(() => {
        if (legacySummaryData && currentYear !== null) {
            let creditSummary: SummaryDto[][] = [];
            let sixYearSummary: SummaryDto[][] = [];
            legacySummaryData.map((item: SummaryDto[], index) => {
                if (index < 6) {
                    creditSummary[creditSummary.length] = item;
                    sixYearSummary[index] = item;
                }

                if (item[1].text.toLowerCase() === "true") {
                    setIsLegacyYearPartialyCompleted(true);
                }
            });
            setLegacyCreditSummaryData(creditSummary);
            setLegacySixYearSummaryData(sixYearSummary);
        }
    }, [legacySummaryData, currentYear]);

    usePortalScreen(portalScreenContext('SummaryForm'), undefined, !((getCreditSummaryStatus === ApiRequestStatus.Pending || currentYearStatus === ApiRequestStatus.Pending ||
        registerStateStatus === ApiRequestStatus.Pending || staticDataStateStatus === ApiRequestStatus.Pending ||
        personalDetailsStatus === ApiRequestStatus.Pending)));

        if (getCreditSummaryStatus === ApiRequestStatus.Pending || currentYearStatus === ApiRequestStatus.Pending ||
        registerStateStatus === ApiRequestStatus.Pending || staticDataStateStatus === ApiRequestStatus.Pending ||
        personalDetailsStatus === ApiRequestStatus.Pending) {
        return <LoadingComponent message={MESSAGE_PROCESSING_DETAILS} />
    }

    return <>
        <Box component={Paper} sx={{ "& .MuiPaper-root": { width: "unset", marginLeft: "0" }, minWidth: "100%", padding: 2 }}>
            <Grid container rowSpacing={4}>

                <Grid size={{ xs: 12 }}></Grid>

                <Grid size={{ xs: 12 }}>
                    <Typography variant='h4'>6-year summary</Typography>
                </Grid>
                <Grid size={{ xs: 12 }}></Grid>
            </Grid>

            {
                ((creditSummaryData && creditSummaryData?.length > 0) || (legacyCreditSummaryData && legacyCreditSummaryData?.length > 0)) &&
                <Grid size={{ xs: 12 }} sx={{ paddingTop: 2, paddingBottom: 2, display: { xs: 'block', md: 'none' } }}>
                    <PDFDownloadLink document={<PdfDocument summaryTitles={summaryTitles} summaryData={creditSummaryData}
                        legacyTitles={legacyTitles} legacySummaryData={legacyCreditSummaryData} registrationDetails={registrationDetails} schemes={schemes} registrationTypes={registrationTypes}
                        personName={titles?.find(x => x.id === personalDetails?.titleId)?.value + ' ' + personalDetails?.firstName + ' ' +
                            personalDetails?.lastName} />}
                        fileName="PCS Statement of Participation.pdf" onClick={portalAction(portalScreenContext('SummaryForm'), 'SummaryForm.download_pdf', () => {})}>
                        {({ loading }) =>
                            loading === true ? <>Loading document...</> :
                                <Button variant="contained" color='primary'>View / Download Statement</Button>}
                    </PDFDownloadLink>
                </Grid>
            }

            <Grid container rowSpacing={4} sx={{ display: { xs: 'block', md: 'none' } }}>
                <SummaryTableMobileView sixYearSummaryData={sixYearSummaryData} totalOfSummary={totalOfSummary} isYearPartialyCompleted={isYearPartialyCompleted} />
            </Grid>

            <Grid container rowSpacing={4} sx={{ display: { xs: 'none', md: 'block' } }}>
                <SummaryTable sixYearSummaryData={sixYearSummaryData} totalOfSummary={totalOfSummary} isYearPartialyCompleted={isYearPartialyCompleted} />
            </Grid>
        </Box>

        {legacySummaryData && legacySummaryData?.length > 0 && <>
            <Box component={Paper} sx={{ "& .MuiPaper-root": { width: "unset", marginLeft: "0" }, minWidth: "100%", display: { xs: 'none', md: 'block' } }} >
                <Grid container rowSpacing={4}>

                    <Grid size={{ xs: 12 }}></Grid>

                    <Grid size={{ xs: 12 }} sx={{ marginLeft: '2%' }}>
                        <Typography variant='h4'>Pre 2025 summary</Typography>
                    </Grid>
                    <Grid size={{ xs: 12 }}></Grid>
                </Grid>

                <LegacySummaryTable legacySixYearSummaryData={legacySixYearSummaryData} isLegacyYearPartialyCompleted={isLegacyYearPartialyCompleted} />
            </Box>
        </>
        }

        {
            ((creditSummaryData && creditSummaryData?.length > 0) || (legacyCreditSummaryData && legacyCreditSummaryData?.length > 0)) &&
            <Grid size={{ xs: 12 }} sx={{ textAlign: 'right', paddingTop: 2, display: { xs: 'none', md: 'block' } }}>
                <PDFDownloadLink document={<PdfDocument summaryTitles={summaryTitles} summaryData={creditSummaryData}
                    legacyTitles={legacyTitles} legacySummaryData={legacyCreditSummaryData} registrationDetails={registrationDetails} schemes={schemes} registrationTypes={registrationTypes}
                    personName={titles?.find(x => x.id === personalDetails?.titleId)?.value + ' ' + personalDetails?.firstName + ' ' +
                        personalDetails?.lastName} />}
                    fileName="PCS Statement of Participation.pdf" onClick={portalAction(portalScreenContext('SummaryForm'), 'SummaryForm.download_pdf', () => {})}>
                    {({ loading }) =>
                        loading === true ? <>Loading document...</> :
                            <Button variant="contained" color='primary'>View / Download Statement</Button>}
                </PDFDownloadLink>
            </Grid>
        }
    </>
}
